import { useState, useEffect } from "react";
import { X, Eye, ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface RecentProduct {
  id: string;
  name: string;
  image: string;
  viewedAt: number;
}

const MAX_RECENT = 3;

export const trackProductView = (product: { id: string; name: string; image: string }) => {
  try {
    const stored = localStorage.getItem("recently-viewed-products");
    let items: RecentProduct[] = stored ? JSON.parse(stored) : [];
    items = items.filter((p) => p.id !== product.id);
    items.unshift({ ...product, viewedAt: Date.now() });
    items = items.slice(0, MAX_RECENT);
    localStorage.setItem("recently-viewed-products", JSON.stringify(items));
  } catch {}
};

const RecentlyViewed = () => {
  const [items, setItems] = useState<RecentProduct[]>([]);
  const [isDismissed, setIsDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const stored = localStorage.getItem("recently-viewed-products");
      if (stored) setItems(JSON.parse(stored));
    } catch {}
  }, [location.pathname]);

  const isOnProductPage = location.pathname.startsWith("/products/") && location.pathname !== "/products/customization";
  
  if (isDismissed || items.length === 0 || isOnProductPage || location.pathname === "/contact") return null;

  return (
    <div className="fixed bottom-20 left-4 z-40 max-w-xs animate-fade-in hidden md:block">
      <div className="glass-vibrant rounded-xl p-3 shadow-lg border border-border/30">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Eye className="w-3 h-3" />
            <span>Recently viewed</span>
          </div>
          <button onClick={() => setIsDismissed(true)} className="p-0.5 hover:bg-secondary/50 rounded">
            <X className="w-3 h-3 text-muted-foreground" />
          </button>
        </div>
        <div className="space-y-2">
          {items.slice(0, 2).map((item) => (
            <Link
              key={item.id}
              to={`/products/${item.id}`}
              className="flex items-center gap-2 group hover:bg-secondary/30 rounded-lg p-1.5 transition-colors"
            >
              <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
              <span className="text-xs font-medium text-foreground group-hover:text-primary transition-colors flex-1 truncate">
                {item.name}
              </span>
              <ArrowRight className="w-3 h-3 text-muted-foreground group-hover:text-primary transition-colors" />
            </Link>
          ))}
        </div>
        <Link to="/contact" className="mt-2 block">
          <Button size="sm" className="w-full text-xs h-7">Get Quote</Button>
        </Link>
      </div>
    </div>
  );
};

export default RecentlyViewed;
